module.exports = __webpack_public_path__ + "images/emails/bg-page-l-0cde9453.png";